"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shuffle = exports.arrayAsRecord = exports.consolidate = void 0;
const __1 = require("..");
function consolidate(elements, key, merge, merged = []) {
    for (const element of elements) {
        const existing = merged.find(other => other[key] === element[key]);
        if (!existing) {
            merged.push(element);
            continue;
        }
        merge(existing, element);
    }
    return merged;
}
exports.consolidate = consolidate;
function arrayAsRecord(elements, mkRecordEntry) {
    return elements.reduce((record, key) => {
        record[key] = mkRecordEntry(key);
        return record;
    }, {});
}
exports.arrayAsRecord = arrayAsRecord;
function shuffle(array) {
    array = array.slice();
    const shuffled = Array.of();
    while (array.length > 0) {
        let next = (0, __1.random)(0, array.length - 1);
        shuffled.push(...array.splice(next, 1));
    }
    return shuffled;
}
exports.shuffle = shuffle;
